import React, {Component} from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import id from "@irati/utils/id"

import {ActionsContainer, ScheduleCard} from "../"
import ActionList from "../Actions/ActionList"


const CycleContainer = styled.div``


class CycleList extends Component {
  static propTypes = {
    cycleList: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired
  }
  static defaultProps = {}


  render() {
    const idNamespace = id("active-cycle-list", this.props, {force: true})
    const {cycleList, onChange} = this.props

    return (
      <CycleContainer>
        {cycleList.map((cycle) => (
          <ScheduleCard key={cycle.id} schedule={cycle} id={id(cycle.id, idNamespace)}>
            <ActionsContainer>
              <ActionList
                id={id(cycle.id, idNamespace)}
                onChange={onChange}
                schedule={cycle} />
            </ActionsContainer>
          </ScheduleCard>
        ))}
      </CycleContainer>
    )
  }
}

export default CycleList
